import { render, staticRenderFns } from "./ProfileScoreBar.vue?vue&type=template&id=2ae55f3a&"
import script from "./ProfileScoreBar.vue?vue&type=script&lang=js&"
export * from "./ProfileScoreBar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileScoreBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports